import Icon from '../../../../../assets/icon-updatejobs.svg?react';
import TenantScheduler from '../../../../../components/updatejobs/TenantScheduler';
import {READ_JOB_SCHEDULE} from '../../../../../components/updatejobs/consts';

export const tenantSchedulerBaseRoute = {
	label: {
		id: 'assetgroup.detail.updatejob.title',
		defaultValue: 'Firmware Update'
	},
	component: TenantScheduler,
	iconSvg: Icon,
	requiredAuthorities: [READ_JOB_SCHEDULE]
};
